import styles from "./style.module.scss";
// import LegalSectorInsightIcon from "./icons/legalSectorInsightIcon";
import B2BLeadCultivationIcon from "./icons/b2bLeadCultivationIcon";
import { motion } from "framer-motion";
import { ReactNode, useState } from "react";
import useWindowSize from "@hooks/useWindowSize";
// import { useDomainContext } from "@hooks/useDomainContext";
export type ListEl = {
    title: string;
    tabName: string;
    slug: string;
    description: string;
    icon: ReactNode;
};
// const b2bCategories = [
//     "b2b",
//     "fleet-management",
//     "business-phone-systems",
//     "crm",
//     "credit-card-processing",
//     "clinical-trials",
//     "forklifts",
//     "point-of-sale",
//     "payroll",
//     "peo",
//     "medical-software",
//     "debt-relief",
//     "sb-fleet-management",
//     "sb-business-phone-systems",
//     "sb-crm",
//     "sb-credit-card-processing",
//     "sb-clinical-trials",
//     "sb-forklifts",
//     "sb-point-of-sale",
//     "sb-payroll",
//     "sb-peo-employee-leasing",
//     "sb-medical-software",
//     "sb-debt-relief",
// ];
const strategicLeadGenerationList = [
    {
        title: "B2B Lead Cultivation",
        tabName: "B2B",
        slug: "b2b",
        description:
            "A shocking finding by Marketing Donut reveals that 80% of leads go unexplored, resulting in a wide expanse of lost opportunities. Our advanced methods and systems are designed to identify and cultivate genuine leads, ensuring every potential client is engaged through follow-up messages or direct calls. This approach positions us to deliver high-quality prospects to your business, enhancing customer loyalty. We have vast experience working with a wide range of industries and helping your company to serve other businesses.",
        icon: <B2BLeadCultivationIcon />,
    },
];
const paragraphsStyle =
    "lg:mt-8 mt-6 font-light lg:text-lg 3xl:text-[26px] 3xl:leading-[2.5rem] text-base lg:leading-8 text-[#351C4F]";
export default function StrategicLeadGeneration({
    mainData,
}: {
    mainData?: {
        title?: string;
        topDescription?: string;
        bottomDescription?: string;
        list?: ListEl[];
    };
}) {
    // const { category } = useDomainContext();

    const windowSize = useWindowSize();
    const [selectedEl, setSelectedEl] = useState(
        mainData?.list
            ? mainData.list[0].slug
            : strategicLeadGenerationList[0].slug,
    );
    // if (category?.slug === "legal") {
    //     strategicLeadGenerationList.unshift({
    //         title: "Legal Sector Insight",
    //         tabName: "Legal",
    //         slug: "legal",
    //         description:
    //             "85% of law firms face challenges in new client acquisition, as noted by the American Bar Association. The complexity of legal terminology and the daunting nature of lawyer interactions can deter potential clients. At SeveralBrands, we excel in crafting straightforward, engaging content and advertisements that elevate client confidence, effectively targeting and securing signed retainers within our legal network with minimal drop-off rates.",
    //         icon: <LegalSectorInsightIcon />,
    //     });
    // }

    const filteredList =
        windowSize.width < 1024
            ? [
                  (
                      (mainData?.list
                          ? mainData?.list
                          : strategicLeadGenerationList) as ListEl[]
                  ).find((el) => el.slug === selectedEl),
              ]
            : mainData?.list
            ? [...mainData.list]
            : [...strategicLeadGenerationList];

    const showTheTabListOnMobile =
        strategicLeadGenerationList.length > 1 ||
        (mainData?.list && mainData?.list?.length > 1);
    return (
        <section className={styles["bgStyle"]}>
            <motion.div
                transition={{ duration: 1.5 }}
                initial={{ opacity: 0, y: 150 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="lg:py-32 py-16"
            >
                <h2 className="text-[#351C4F] font-bold  3xl:text-7xl lg:text-5xl lg:leading-[4rem] text-2xl leading-9 text-center 3xl:max-w-[1415px] 3xl:leading-[5.5rem] lg:max-w-[915px] mx-auto">
                    {mainData?.title ??
                        "Strategic Lead Generation: Timing Meets Precision"}
                </h2>
                <p className={`${paragraphsStyle} text-center`}>
                    {mainData?.topDescription ??
                        "Our prowess in spearheading lead-generation efforts across diverse industries stems from our unique approach."}
                </p>
                {showTheTabListOnMobile && (
                    <div className="mt-10 flex justify-center gap-8  lg:hidden">
                        {(mainData?.list
                            ? mainData.list
                            : strategicLeadGenerationList
                        ).map((el) => (
                            <motion.button
                                whileHover={{
                                    scale: [1, 1.2, 1],
                                    transition: {
                                        duration: 0.8,
                                        repeat: Infinity,
                                        delay: 0.3,
                                    },
                                }}
                                key={el.slug}
                                className={`block text-[#37367D] lg:text-lg lg:px-7 px-4 lg:py-2 py-1 cursor-pointer  ${
                                    el.slug === selectedEl
                                        ? "border border-[#37367D] rounded-3xl"
                                        : ""
                                }`}
                                onClick={() => {
                                    setSelectedEl(el.slug);
                                }}
                            >
                                {el.tabName}
                            </motion.button>
                        ))}
                    </div>
                )}
                <ul>
                    {(filteredList as ListEl[]).map((el) => (
                        <li key={el.title} className={styles["stepStyle"]}>
                            <div className=" max-w-[800px]  3xl:max-w-[1200px]">
                                <h3 className="text-[#351C4F]  text-lg lg:text-2xl 3xl:text-4xl lg:leading-10 mt-7 font-bold text-center lg:text-left">
                                    {el.title}
                                </h3>
                                <p
                                    className={`${paragraphsStyle} text-center lg:text-left`}
                                >
                                    {el.description}
                                </p>
                            </div>
                            <div className=" relative 3xl:w-[310px] 3xl:h-[310px] lg:w-[230px] lg:h-[250px] w-[100px] h-[100px]">
                                {el.icon}
                            </div>
                        </li>
                    ))}
                </ul>
                <p className={`${paragraphsStyle} text-center`}>
                    {mainData?.bottomDescription ??
                        `Outsourcing your lead generation isn't just a time saver—it's a cost-effective strategy to boost your business's growth. Partner with us for unparalleled lead generation expertise, allowing you to concentrate on perfecting your offerings and achieving outstanding results for your clients.`}
                </p>
            </motion.div>
        </section>
    );
}
